import React from "react";
function SearchInput(_ref) {
  var getAutocomplete = _ref.getAutocomplete,
    getButtonProps = _ref.getButtonProps,
    getInputProps = _ref.getInputProps;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "sui-search-box__wrapper"
  }, React.createElement("input", Object.assign({}, getInputProps())), getAutocomplete()), React.createElement("input", Object.assign({}, getButtonProps())));
}
export default SearchInput;